import sessionMixin from "@/components/shared/mixins/sessionMixin";
import { mapState } from "vuex";

export default {
  name: "MobileSteps",
  props: [
    "enableZooxpay",
    "isMaster",
    "hasChargeToPayAtCheckin",
    "stepTitlesMap"
  ],
  mixins: [sessionMixin],
  data() {
    return {
      showPayment: false,
      lastStep: 3,
      currentIsMaster: false,
      currentHasChargeToPayAtCheckin: false
    };
  },
  watch: {
    hasChargeToPayAtCheckin: function(val) {
      this.currentHasChargeToPayAtCheckin = val;
      this.setSteps();
    },
    isMaster: function(val) {
      this.currentIsMaster = val;
      this.setSteps();
    }
  },
  computed: {
    ...mapState(["currentMobileStep"])
  },
  mounted() {
    this.currentIsMaster = this.isMaster;
    this.currentHasChargeToPayAtCheckin = this.hasChargeToPayAtCheckin;
    this.setSteps();
    this.currStep = this.currentMobileStep;
  },
  methods: {
    getStepTitle(id) {
      if (this.stepTitlesMap && this.stepTitlesMap[id]) {
        return this.stepTitlesMap[id];
      }
      return "";
    },
    setSteps: function() {
      if (
        this.enableZooxpay &&
        this.currentIsMaster &&
        this.currentHasChargeToPayAtCheckin
      ) {
        this.showPayment = true;
        this.lastStep = 4;
      } else {
        this.showPayment = false;
        this.lastStep = 3;
      }
    }
  }
};
